import React from 'react';

import NumberMaskField, { NumberMaskedFieldProps } from '../NumberMaskedField';

export type CurrencyFieldProps = NumberMaskedFieldProps;

const default_props = {
  prefix: '$',
  thousandSeparator: true,
  decimalScale: 2,
  fixedDecimalScale: true,
  placeholder: '$',
};

export const CurrencyField = ({ MaskedProps, ...props }: CurrencyFieldProps): JSX.Element => {
  return (
    <NumberMaskField
      MaskedProps={{
        ...default_props,
        ...MaskedProps,
      }}
      {...props}
    />
  );
};

export default CurrencyField;
